var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"el-menu-item-drug",class:{
    'is-active': _vm.active,
    'is-disabled': _vm.disabled
  },attrs:{"role":"menuitem","tabindex":"-1"},on:{"click":_vm.handleClick,"blur":_vm.onMouseLeave,"mouseleave":_vm.onMouseLeave}},[(
      _vm.parentMenu.$options.componentName === 'ElMenu' &&
        _vm.rootMenu.collapse &&
        _vm.$slots.title
    )?_c('el-tooltip',{attrs:{"effect":"dark","placement":"right"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("title")],2),_c('div',{staticStyle:{"position":"absolute","left":"0","top":"0","height":"100%","width":"100%","display":"inline-block","box-sizing":"border-box","padding":"0 20px"}},[_vm._t("default")],2)]):[_vm._t("default"),_vm._t("title")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }